// extracted by mini-css-extract-plugin
export default {"wrapper":"SeasonRoundFlagItem_wrapper__+49Er"};